<div class="my-5">
    <sm-page-header [breadcrumb]="breadcrumb" title="meeting.breadcrumb.convene"> </sm-page-header>
    <div class="flex flex-row gap-5">
        <div class="content w-3/4">
            <sm-form-builder [formObject]="formObject"></sm-form-builder>
        </div>
        <div class="flex flex-col gap-5 w-1/4">
            <sm-status [status]="`meeting.status.${status}`"></sm-status>
            <div class="content h-fit">
                <sm-block-builder [blocks]="controlBlocks"></sm-block-builder>

            </div>
        </div>
    </div>
    <sm-meeting-invitee-dialog #dialog [inviteeFormObject]="inviteeFormObject" [isMeetingConvened]="true"></sm-meeting-invitee-dialog>
    <sm-dialog #dialogPv [dialog]="pvDialogObject"></sm-dialog>
    <sm-drawer #drawerPvExtraits [drawer]="pvExtraitsDrawerObject"></sm-drawer>
    <sm-dialog #snippetsDialogUpload [dialog]="snippetsDialogUploadObject"></sm-dialog>
</div>